import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1965d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "Qual o tipo de estrutura principal do imóvel?"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  class: "",
  title: "Observações"
}
const _hoisted_9 = { class: "ant-row ui-espaco-campos" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = {
  class: "",
  title: "Qual o tipo de estrutura do telhado (tesoura e travessas)?"
}
const _hoisted_12 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  class: "",
  title: "Observações"
}
const _hoisted_16 = { class: "ant-row ui-espaco-campos" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = {
  class: "",
  title: "Qual o tipo de cobertura do telhado ?"
}
const _hoisted_19 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  class: "",
  title: "Observações"
}
const _hoisted_23 = { class: "ant-row ui-espaco-campos" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_25 = {
  class: "",
  title: "Como são as paredes laterais / material de construção (fechamento) ?"
}
const _hoisted_26 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  class: "",
  title: "Observações"
}
const _hoisted_30 = { class: "ant-row ui-espaco-campos" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_32 = {
  class: "",
  title: "Os prédios principais estão interligados por esteiras, túneis ou coberturas que possam facilitar propagação de incêndio?"
}
const _hoisted_33 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  class: "",
  title: "Observações"
}
const _hoisted_36 = { class: "ant-row ui-espaco-campos" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_38 = {
  class: "",
  title: "Utiliza isopainel no interior do imóvel como divisórias?"
}
const _hoisted_39 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Tipo existente:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Quantos m2 existe no interior como divisórias:", -1))
const _hoisted_43 = { key: 2 }
const _hoisted_44 = {
  class: "",
  title: "Observações"
}
const _hoisted_45 = { class: "ant-row ui-espaco-campos" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = {
  class: "",
  title: "Existem portas corta-fogo instaladas nas divisas entre compartimentos de risco ou setores?"
}
const _hoisted_48 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  class: "",
  title: "Observações"
}
const _hoisted_51 = { class: "ant-row ui-espaco-campos" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_53 = {
  class: "",
  title: "Possui sistema de geração solar (painéis fotovoltaicos)?"
}
const _hoisted_54 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Localização da instalação:", -1))
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Capacidade instalada (kWp)", -1))
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Ano de instalação", -1))
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { key: 2 }
const _hoisted_65 = {
  class: "",
  title: "Observações"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 3 – ESTRUTURA FÍSICA E CONSTRUÇÃO",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaImovelVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.tipoEstruturaImovelVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.tipoEstruturaImovelEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.tipoEstruturaImovelEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.tipoEstruturaImovelEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual o tipo de estrutura principal do imóvel? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('tipoEstruturaImovel')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.tipoEstruturaImovel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.tipoEstruturaImovel), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoEstruturaImovelVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaImovelAlvenaria,
                        "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelAlvenaria) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Alvenaria")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaImovelMetalica,
                        "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelMetalica) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Metálica")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaImovelPremoldado,
                        "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelPremoldado) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Pré-moldado")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaImovelMista,
                        "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelMista) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Estrutura-mista")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaImovelOutros,
                        "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelOutros) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Outros")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoEstruturaImovelVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.tipoEstruturaImovelObservacoesVisivel,
                              "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.tipoEstruturaImovelObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.tipoEstruturaImovelObservacoes,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaImovelObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaTelhadoVisivel,
                        "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.tipoEstruturaTelhadoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.tipoEstruturaTelhadoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.tipoEstruturaTelhadoEnviarEmail,
                            "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.tipoEstruturaTelhadoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual o tipo de estrutura do telhado (tesoura e travessas)? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('tipoEstruturaTelhado')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.tipoEstruturaTelhado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.ManualPreenchimentoInspecao.tipoEstruturaTelhado), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoEstruturaTelhadoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaTelhadoMetalica,
                        "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoMetalica) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Metálica")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaTelhadoPremoldado,
                        "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoPremoldado) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Pré-moldado")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaTelhadoMadeira,
                        "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoMadeira) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Madeira")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoEstruturaTelhadoOutros,
                        "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoOutros) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Outros")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoEstruturaTelhadoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.tipoEstruturaTelhadoObservacoesVisivel,
                              "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.tipoEstruturaTelhadoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.tipoEstruturaTelhadoObservacoes,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSecao3.tipoEstruturaTelhadoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoVisivel,
                        "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.tipoCoberturaTelhadoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.tipoCoberturaTelhadoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.tipoCoberturaTelhadoEnviarEmail,
                            "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.tipoCoberturaTelhadoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual o tipo de cobertura do telhado ? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('tipoCoberturaTelhado')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.tipoCoberturaTelhado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.ManualPreenchimentoInspecao.tipoCoberturaTelhado), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoCoberturaTelhadoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoTelhaMetalica,
                        "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoTelhaMetalica) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Telha metálica")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoFibrocimento,
                        "onUpdate:checked": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoFibrocimento) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Fibrocimento ")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoPvc,
                        "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoPvc) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("PVC")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoOutros,
                        "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoOutros) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Outros")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoEps,
                        "onUpdate:checked": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoEps) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sanduíche (EPS)")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoPur,
                        "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoPur) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sanduíche (PUR)")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoCoberturaTelhadoPir,
                        "onUpdate:checked": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoPir) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sanduíche (PIR)")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoCoberturaTelhadoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.tipoCoberturaTelhadoObservacoesVisivel,
                              "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.tipoCoberturaTelhadoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.tipoCoberturaTelhadoObservacoes,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedSecao3.tipoCoberturaTelhadoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisVisivel,
                        "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.tipoParedesLateraisVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.tipoParedesLateraisEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.tipoParedesLateraisEnviarEmail,
                            "onUpdate:checked": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.tipoParedesLateraisEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Como são as paredes laterais / material de construção (fechamento) ? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('tipoParedesLaterais')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.tipoParedesLaterais)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.ManualPreenchimentoInspecao.tipoParedesLaterais), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoParedesLateraisVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisAlvenaria,
                        "onUpdate:checked": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisAlvenaria) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Alvenaria")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisMetalico,
                        "onUpdate:checked": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisMetalico) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Metálico")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisIsoPainel,
                        "onUpdate:checked": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisIsoPainel) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Isopainel")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisMadeira,
                        "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisMadeira) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Madeira")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisVidro,
                        "onUpdate:checked": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisVidro) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Vidro")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.tipoParedesLateraisOutros,
                        "onUpdate:checked": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisOutros) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Outros")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.tipoParedesLateraisVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.tipoParedesLateraisObservacoesVisivel,
                              "onUpdate:checked": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.tipoParedesLateraisObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.tipoParedesLateraisObservacoes,
                            "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedSecao3.tipoParedesLateraisObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.prediosInterligadosFacilitamIncendioVisivel,
                        "onUpdate:checked": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.computedSecao3.prediosInterligadosFacilitamIncendioVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.prediosInterligadosFacilitamIncendioVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.prediosInterligadosFacilitamIncendioEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.prediosInterligadosFacilitamIncendioEnviarEmail,
                            "onUpdate:checked": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedSecao3.prediosInterligadosFacilitamIncendioEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.prediosInterligadosFacilitamIncendioEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Os prédios principais estão interligados por esteiras, túneis ou coberturas que possam facilitar propagação de incêndio? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[44] || (_cache[44] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('prediosInterligadosFacilitamIncendio')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao3.prediosInterligadosFacilitamIncendioVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao3.prediosInterligadosFacilitamIncendio,
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.computedSecao3.prediosInterligadosFacilitamIncendio = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao3.prediosInterligadosFacilitamIncendioVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao3.prediosInterligadosFacilitamIncendio,
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.computedSecao3.prediosInterligadosFacilitamIncendio = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.prediosInterligadosFacilitamIncendio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.ManualPreenchimentoInspecao.prediosInterligadosFacilitamIncendio), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.prediosInterligadosFacilitamIncendioVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.prediosInterligadosFacilitamIncendioObservacoesVisivel,
                              "onUpdate:checked": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedSecao3.prediosInterligadosFacilitamIncendioObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.prediosInterligadosFacilitamIncendioObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.prediosInterligadosFacilitamIncendioObservacoes,
                            "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedSecao3.prediosInterligadosFacilitamIncendioObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.usaIsopainelInteriorVisivel,
                        "onUpdate:checked": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.computedSecao3.usaIsopainelInteriorVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.usaIsopainelInteriorVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.usaIsopainelInteriorEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.usaIsopainelInteriorEnviarEmail,
                            "onUpdate:checked": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.computedSecao3.usaIsopainelInteriorEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.usaIsopainelInteriorEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Utiliza isopainel no interior do imóvel como divisórias? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('usaIsopainelInterior')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao3.usaIsopainelInteriorVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao3.usaIsopainelInterior,
                        onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.computedSecao3.usaIsopainelInterior = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao3.usaIsopainelInteriorVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao3.usaIsopainelInterior,
                        onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.computedSecao3.usaIsopainelInterior = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.usaIsopainelInterior)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.ManualPreenchimentoInspecao.usaIsopainelInterior), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao3.usaIsopainelInteriorVisivel && _ctx.computedSecao3.usaIsopainelInterior))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.isoPainelTipoEps,
                          "onUpdate:checked": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.computedSecao3.isoPainelTipoEps) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("EPS")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.isoPainelTipoPur,
                          "onUpdate:checked": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.computedSecao3.isoPainelTipoPur) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("PUR")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.isoPainelTipoPir,
                          "onUpdate:checked": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.computedSecao3.isoPainelTipoPir) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("PIR")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.isoPainelTipoLaRocha,
                          "onUpdate:checked": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.computedSecao3.isoPainelTipoLaRocha) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lã de Rocha")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.isoPainelTipoLaVidro,
                          "onUpdate:checked": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.computedSecao3.isoPainelTipoLaVidro) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lã de Vidro")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _hoisted_42,
                      _createVNode(_component_a_textarea, {
                        "auto-size": true,
                        value: _ctx.computedSecao3.isopainelAreaDivisoriasM2,
                        "onUpdate:value": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.computedSecao3.isopainelAreaDivisoriasM2) = $event)),
                        disabled: _ctx.props.bloquearCampos
                      }, null, 8, ["value", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.usaIsopainelInteriorVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.usaIsopainelInteriorObservacoesVisivel,
                              "onUpdate:checked": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.computedSecao3.usaIsopainelInteriorObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.usaIsopainelInteriorObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.usaIsopainelInteriorObservacoes,
                            "onUpdate:value": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.computedSecao3.usaIsopainelInteriorObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.possuiPortasCortaFogoVisivel,
                        "onUpdate:checked": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.computedSecao3.possuiPortasCortaFogoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.possuiPortasCortaFogoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.possuiPortasCortaFogoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.possuiPortasCortaFogoEnviarEmail,
                            "onUpdate:checked": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.computedSecao3.possuiPortasCortaFogoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.possuiPortasCortaFogoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existem portas corta-fogo instaladas nas divisas entre compartimentos de risco ou setores? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[64] || (_cache[64] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiPortasCortaFogo')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao3.possuiPortasCortaFogoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao3.possuiPortasCortaFogo,
                        onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.computedSecao3.possuiPortasCortaFogo = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao3.possuiPortasCortaFogoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao3.possuiPortasCortaFogo,
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.computedSecao3.possuiPortasCortaFogo = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiPortasCortaFogo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiPortasCortaFogo), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.possuiPortasCortaFogoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.possuiPortasCortaFogoObservacoesVisivel,
                              "onUpdate:checked": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.computedSecao3.possuiPortasCortaFogoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.possuiPortasCortaFogoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.possuiPortasCortaFogoObservacoes,
                            "onUpdate:value": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.computedSecao3.possuiPortasCortaFogoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("label", _hoisted_53, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel,
                        "onUpdate:checked": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao3.possuiSistemaGeracaoSolarEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao3.possuiSistemaGeracaoSolarEnviarEmail,
                            "onUpdate:checked": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.computedSecao3.possuiSistemaGeracaoSolarEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao3.possuiSistemaGeracaoSolarEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Possui sistema de geração solar (painéis fotovoltaicos)? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[71] || (_cache[71] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiSistemaGeracaoSolar')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao3.possuiSistemaGeracaoSolar,
                        onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.computedSecao3.possuiSistemaGeracaoSolar = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao3.possuiSistemaGeracaoSolar,
                        onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.computedSecao3.possuiSistemaGeracaoSolar = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiSistemaGeracaoSolar)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiSistemaGeracaoSolar), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel && _ctx.computedSecao3.possuiSistemaGeracaoSolar))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.geracaoSolarLocalizacaoTelhado,
                          "onUpdate:checked": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.computedSecao3.geracaoSolarLocalizacaoTelhado) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Telhado")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao3.geracaoSolarLocalizacaoSolo,
                          "onUpdate:checked": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.computedSecao3.geracaoSolarLocalizacaoSolo) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Solo/Estrutura independente")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.computedSecao3.geracaoSolarCapacidadeKwp) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_60), [
                            [_vModelText, _ctx.computedSecao3.geracaoSolarCapacidadeKwp]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.computedSecao3.geracaoSolarAnoInstalacao) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_63), [
                            [_vModelText, _ctx.computedSecao3.geracaoSolarAnoInstalacao]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao3.possuiSistemaGeracaoSolarVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("label", _hoisted_65, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao3.possuiSistemaGeracaoSolarObservacoesVisivel,
                              "onUpdate:checked": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.computedSecao3.possuiSistemaGeracaoSolarObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao3.possuiSistemaGeracaoSolarObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao3.possuiSistemaGeracaoSolarObservacoes,
                            "onUpdate:value": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.computedSecao3.possuiSistemaGeracaoSolarObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}